import { useState } from "react";
import { Globals } from "../../global/Globals";

export const infoIcon = ({ infoMessage, handleInfoButton }) => {
  const infoAction = () => {
    handleInfoButton();
  };
  return (
    <img
      src={Globals.IMG.INFO_ICON}
      alt="info icon"
      className="icon-style"
      onClick={infoAction}
    />
  );
};
export const isRequired = (
  text,
  isrequired = true,
  isInfoIcon = false,
  infoMessage = "",
  handleInfoButton
) => {
  return (
    <div>
      <label className="brief-input-top-label-brief">
        {text}
        {isrequired && <span className="required"> *</span>}
        {isInfoIcon && (
          <img
            src={Globals.IMG.INFO_ICON}
            alt="info icon"
            className="icon-style"
            onClick={handleInfoButton}
          />
        )}
      </label>
      {}
    </div>
  );
};
